import React, { useContext, useEffect, useState } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Grid2';

import { MdArrowBack, MdDelete } from 'react-icons/md';
import InputMask from 'react-input-mask';

import { DialogBox } from '../../../../components/singleComponents/dialogs/DialogBox';
import ToasterBox from '../../../../components/singleComponents/toaster/ToasterBox';
import { IOSSwitch } from '../../../../components/textInputs/IOSInputSwitch/IOSSwitch';

import api, { authHeader } from '../../../../../services/API/apiConfig';

import { TourContext } from '../../../../../context/tour';
import {
  AccessPermissionStyled,
  ButtonSubmitStyled,
  DivDeleteStyled,
  HeaderContainerStyled,
  Input2Styled,
  RadioButtonStyled,
  RadioGroupStyled,
  RootStyled,
  SectionTitleStyled,
  SubmitContainerStyled,
  TitlePageStyled,
} from './index.styles';

const defaultPermissions = [
  { text: 'Lançamentos', value: 'payables', checked: false },
  { text: 'Orçamento', value: 'budgets', checked: false },
  { text: 'Cronograma', value: 'schedules', checked: false },
  { text: 'Fotos', value: 'pictures', checked: false },
  { text: 'Documentos', value: 'documents', checked: false },
  { text: 'Dashboard', value: 'dashboard', checked: false },
];

export function FormClients() {
  const navigate = useNavigate();
  const match = useMatch('/new-client/:id');

  const id = match ? match.params.id : null;

  const { setTutorialStep } = useContext(TourContext);

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);

  const [address, setAddress] = useState('');
  const [addressNum, setAddressNum] = useState('');
  const [cep, setCep] = useState('');
  const [invalidCep, setInvalidCep] = useState(false);
  const [cellphone, setCellphone] = useState('');
  const [city, setCity] = useState('');
  const [document1, setDocument1] = useState('');
  const [document2, setDocument2] = useState('');
  const [documentType, setDocumentType] = useState('CNPJ');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [state, setState] = useState('');
  const [addressDetails, setAddressDetails] = useState('');
  const [checked, setChecked] = useState(false);

  const [successMessage, setSuccessMessage] = useState('');
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [permissions, setPermissions] = useState(defaultPermissions);

  function handleGoBack() {
    navigate(-1);
  }

  const resetToaster = () => {
    setTimeout(() => {
      setErrorMessage('');
      setErrorSubmit(false);
    }, 4000);
  };

  const handleChangePermissions = (event) => {
    const { value } = event.target;
    const item = permissions.find((permission) => permission.value === value);
    const newItem = permissions.map((permission) =>
      value === permission.value
        ? { ...permission, checked: !item.checked }
        : permission
    );
    setPermissions(newItem);
  };

  useEffect(() => {
    setTutorialStep(5);

    if (id) {
      api
        .get(`/users/${id}`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          if (data.document2) {
            if (data.document2.length === 11) {
              setDocumentType('CPF');
            } else {
              setDocumentType('CNPJ');
            }
          }
          setAddress(data.address);
          setAddressNum(data.address_num);
          setAddressDetails(data.address_details);
          setCep(data.zipcode);
          setCellphone(data.cellphone);
          setCity(data.city);
          setDocument1(data.document1);
          setDocument2(data.document2);
          setEmail(data.email);
          setName(data.name);
          setPhone(data.phone);
          setState(data.state);
          setChecked(data.has_access);
          setPermissions(() =>
            defaultPermissions.map((p) => {
              if (!data.permissions.includes(p.value)) {
                return { ...p, checked: false };
              }
              return { ...p, checked: true };
            })
          );
        });
    }
  }, []);

  const onBlurCep = (event) => {
    const { value } = event.target;
    const zipcode = value.replace(/[^0-9]/g, '');

    if (zipcode?.length === 8) {
      fetch(`https://viacep.com.br/ws/${zipcode}/json/`)
        .then((response) => response.json())
        .then((data) => {
          if (data.erro) {
            setInvalidCep(true);
            setCity('');
            setState('');
            setAddress('');
          } else {
            setInvalidCep(false);
            setCep(data.cep);
            setCity(data.localidade);
            setState(data.uf);
            setAddress(data.logradouro);
          }
        });
    } else {
      setInvalidCep(true);
    }
  };

  const validateRequiredFields = () => {
    const document = document2.replace(/\D/g, '');
    const documentLength = documentType === 'CNPJ' ? 14 : 11;

    if (!name || !name.includes(' ')) {
      return 'O campo Nome Completo deve estar preenchido corretamente.';
    }
    if (!document || document.length !== documentLength) {
      return `${documentType} inválido. Verifique o número digitado`;
    }
    return '';
  };

  const onSubmit = (event) => {
    event.preventDefault();

    const requiredFieldsError = validateRequiredFields();

    if (requiredFieldsError) {
      setErrorSubmit(true);
      setErrorMessage(requiredFieldsError);
      resetToaster();
    } else {
      const permissionsTemp = permissions
        .filter((p) => p.checked)
        .map((p) => p.value);

      const data = {
        user: {
          address,
          address_num: addressNum,
          address_details: addressDetails,
          cellphone,
          city,
          document1,
          document2,
          email,
          name,
          phone,
          state,
          zipcode: cep,
          has_access: checked,
          permissions: permissionsTemp,
        },
      };

      if (id) {
        api
          .patch(`/users/${id}`, data, {
            headers: authHeader(),
          })
          .then((res) => {
            if (res.data.status === 0) {
              setSuccessMessage('Cliente editado com sucesso.');
              setSuccessSubmit(true);

              setTimeout(() => {
                handleGoBack();
              }, 2000);
            }
            if (res.data.status === 2) {
              const errors = Object.keys(res.data.messages);

              if (errors.includes('document2')) {
                setErrorMessage(
                  'O documento informado não é um CPF/CNPJ válido.'
                );
                setErrorSubmit(true);
                resetToaster();
              } else if (errors.includes('email')) {
                setErrorMessage('O campo E-mail deve conter um e-mail válido.');
                setErrorSubmit(true);
                resetToaster();
              } else if (errors.includes('state')) {
                setErrorMessage(
                  'O campo Estado deve conter a sigla de um estado válido'
                );
                setErrorSubmit(true);
                resetToaster();
              }
            }
          });
      } else {
        const data2 = { user: {} };

        Object.entries(data.user).forEach(([key, value]) => {
          if (value !== null) {
            data2.user[key] = value;
          }
        });

        api
          .post('/users', data2, {
            headers: authHeader(false),
          })
          .then((res) => {
            const { status } = res.data;

            if (status === 2) {
              const errors = Object.keys(res.data.messages);

              if (errors.includes('document2')) {
                setErrorMessage(
                  'O documento informado não é um CPF/CNPJ válido.'
                );
                setErrorSubmit(true);
                resetToaster();
              } else if (errors.includes('email')) {
                setErrorMessage('O campo E-mail deve conter um e-mail válido.');
                setErrorSubmit(true);
                resetToaster();
              } else if (errors.includes('state')) {
                setErrorMessage(
                  'O campo Estado deve conter a sigla de um estado válido'
                );
                setErrorSubmit(true);
                resetToaster();
              }
            } else if (status === 0) {
              setSuccessMessage('Cliente cadastrado com sucesso.');
              setSuccessSubmit(true);
              setTimeout(() => {
                handleGoBack();
              }, 2000);
            }
          })
          .catch(() => {
            setErrorMessage(
              'Erro ao tentar cadastrar cliente. Tente novamente!'
            );
            setErrorSubmit(true);
            resetToaster();
          });
      }
    }
  };

  const handleChangeRadio = (event) => {
    setDocumentType(event.target.value);
  };

  const handleDeleteClient = () => {
    if (id) {
      api
        .delete(`/users/${id}`, {
          headers: authHeader(),
        })
        .then(() => {
          setOpenDialogDelete(false);
          setSuccessMessage('Cliente removido.');
          setSuccessSubmit(true);
          setTimeout(() => {
            handleGoBack();
          }, 3000);
        });
    }
  };

  const handleOpenDialog = () => {
    if (id) {
      setOpenDialog(true);
    } else {
      navigate('/clients');
    }
  };

  return (
    <RootStyled>
      <Button
        variant="text"
        style={{
          background: 'none',
          marginLeft: -20,
        }}
        onClick={handleOpenDialog}
      >
        <MdArrowBack size={25} />
      </Button>
      <TitlePageStyled variant="h2">
        {id !== null ? 'Editar cliente' : 'Cadastrar cliente'}
      </TitlePageStyled>

      <div id="personal-info">
        <HeaderContainerStyled>
          <SectionTitleStyled variant="h4">
            Informações pessoais
          </SectionTitleStyled>
          <DivDeleteStyled onClick={() => setOpenDialogDelete(true)}>
            {id && (
              <>
                <MdDelete size={24} />
                <Typography>Remover cliente</Typography>
              </>
            )}
          </DivDeleteStyled>
        </HeaderContainerStyled>
        {successSubmit && <ToasterBox message={successMessage} />}
        {errorSubmit && <ToasterBox message={errorMessage} />}
        <Grid2 container spacing={2}>
          <Grid2 item size={6}>
            <TextField
              fullWidth
              label="Nome Completo"
              variant="outlined"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid2>
          <Grid2 item size={3}>
            <TextField
              fullWidth
              type="number"
              label="RG"
              variant="outlined"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={document1}
              onChange={(e) => setDocument1(e.target.value)}
            />
          </Grid2>
          <Grid2 item size={3}>
            <div>
              <RadioGroupStyled
                row
                value={documentType}
                onChange={handleChangeRadio}
              >
                <RadioButtonStyled
                  value="CNPJ"
                  label="CNPJ"
                  control={<Radio color="primary" />}
                />
                <RadioButtonStyled
                  value="CPF"
                  label="CPF"
                  control={<Radio color="primary" />}
                />
              </RadioGroupStyled>
              {documentType === 'CPF' ? (
                <InputMask
                  mask="999.999.999-99"
                  value={document2}
                  onChange={(e) => setDocument2(e.target.value)}
                >
                  {() => (
                    <TextField
                      label={documentType}
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      variant="outlined"
                      color="secondary"
                      sx={{ width: '100%' }}
                    />
                  )}
                </InputMask>
              ) : (
                <InputMask
                  mask="99.999.999/9999-99"
                  value={document2}
                  onChange={(e) => setDocument2(e.target.value)}
                >
                  {() => (
                    <TextField
                      label={documentType}
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      variant="outlined"
                      color="secondary"
                      sx={{ width: '100%' }}
                    />
                  )}
                </InputMask>
              )}
            </div>
          </Grid2>
          <Grid2 item size={2}>
            <InputMask
              mask="99999-999"
              onBlur={onBlurCep}
              value={cep}
              onChange={(e) => setCep(e.target.value)}
            >
              {() => (
                <Input2Styled
                  sx={{ width: '100%' }}
                  error={invalidCep}
                  helperText={invalidCep && 'CEP inválido'}
                  label="CEP"
                  variant="outlined"
                  color="secondary"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                />
              )}
            </InputMask>
          </Grid2>
          <Grid2 item size={8}>
            <TextField
              sx={{ width: '100%' }}
              id="address"
              label="Endereço"
              variant="outlined"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </Grid2>
          <Grid2 item size={2}>
            <Input2Styled
              sx={{ width: '100%' }}
              id="number"
              type="number"
              label="Número"
              variant="outlined"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={addressNum}
              onChange={(e) => setAddressNum(e.target.value)}
            />
          </Grid2>
          <Grid2 item size={3}>
            <TextField
              fullWidth
              id="city"
              label="Cidade"
              variant="outlined"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </Grid2>
          <Grid2 item size={1}>
            <TextField
              fullWidth
              id="state"
              label="Estado"
              variant="outlined"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={state}
              onChange={(e) => setState(e.target.value)}
            />
          </Grid2>
          <Grid2 item size={8}>
            <TextField
              fullWidth
              id="complement"
              label="Complemento"
              variant="outlined"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={addressDetails}
              onChange={(e) => setAddressDetails(e.target.value)}
            />
          </Grid2>
          <Grid2 item size={3}>
            <InputMask
              mask="(99) 9999-9999"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            >
              {() => (
                <TextField
                  fullWidth
                  id="telephone"
                  label="Telefone"
                  variant="outlined"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                />
              )}
            </InputMask>
          </Grid2>
          <Grid2 item size={3}>
            <InputMask
              mask="(99) 99999-9999"
              value={cellphone}
              onChange={(e) => setCellphone(e.target.value)}
            >
              {() => (
                <TextField
                  fullWidth
                  id="cellphone"
                  label="Celular"
                  variant="outlined"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                />
              )}
            </InputMask>
          </Grid2>
          <Grid2 item size={6}>
            <TextField
              fullWidth
              id="email"
              label="E-mail"
              variant="outlined"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid2>
        </Grid2>
      </div>

      <div id="account">
        <SectionTitleStyled variant="h4">Conta</SectionTitleStyled>
        <AccessPermissionStyled id="permission">
          <Typography variant="body1">Permissão de acesso</Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <IOSSwitch
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
              }
            />
          </FormGroup>
        </AccessPermissionStyled>
        <Typography variant="body1">
          Nesta área, você pode selecionar as permissões que deseja conceder ao
          seu cliente para acesso e utilização
        </Typography>
      </div>

      {checked && (
        <>
          <SectionTitleStyled variant="h4">
            Acesso ao SIOON Clientes
          </SectionTitleStyled>
          <FormGroup style={{ marginLeft: 16 }}>
            {!!permissions.length &&
              permissions.map((permission) => (
                <FormControlLabel
                  key={permission.value}
                  control={
                    <Checkbox
                      checked={permission.checked}
                      value={permission.value}
                      onChange={(e) => handleChangePermissions(e)}
                    />
                  }
                  label={permission.text}
                />
              ))}
          </FormGroup>
        </>
      )}
      <SubmitContainerStyled>
        <ButtonSubmitStyled id="save-client" onClick={(e) => onSubmit(e)}>
          Salvar
        </ButtonSubmitStyled>
      </SubmitContainerStyled>
      <DialogBox
        title="Cancelar edição de cadastro"
        content="Deseja realmente cancelar a edição? Todas as informações inseridas serão perdidas."
        openDialog={openDialog}
        closeDialog={() => setOpenDialog(false)}
        mainAction={() => {
          handleGoBack();
        }}
      />
      <DialogBox
        title="Remover cliente"
        content="Deseja realmente remover esse cliente? Todas as informações inseridas serão perdidas."
        openDialog={openDialogDelete}
        closeDialog={() => setOpenDialogDelete(false)}
        mainAction={handleDeleteClient}
      />
    </RootStyled>
  );
}
